import React from 'react';
import { List, Card, Dropdown } from 'semantic-ui-react';
import MomentDate from '../../../../common/MomentDate';
import { dispatch } from '@rematch/core/';
const options = [
    { key: 1, text: 'January', value: 'January' },
    { key: 2, text: 'February', value: "February" },
    { key: 3, text: 'March', value: 'March' },
    { key: 4, text: 'April', value: 'April' },
    { key: 5, text: 'May', value: 'May' },
    { key: 6, text: 'June', value: 'June' },
    { key: 7, text: 'July', value: 'July' },
    { key: 8, text: 'August', value: 'August' },
    { key: 9, text: 'September', value: 'September' },
    { key: 10, text: 'October', value: 'October' },
    { key: 11, text: 'November', value: 'November' },
    { key: 12, text: 'December', value: 'December' },
]
export default class AccountPreference extends React.Component {
    updateMonth = (e, data) => {
        let payload = {
            _id: this.props.selectedAccount._id,
            yearStartsFrom: data.value
        }
        dispatch.registerAccount.UpdateAccountDetails(payload)
    }
    render() {
        const { selectedAccount } = this.props
        return (
            <Card>
                <Card.Header>Account Preferences </Card.Header>
                <Card.Content className="pad_0">
                    <List divided verticalAlign='middle'>
                        <List.Item className="singleLine">
                            <List.Content floated='right'>
                                English
                                </List.Content>
                            <List.Content >
                                <List.Header >Language</List.Header>
                            </List.Content>
                        </List.Item>
                        <List.Item className="singleLine">
                            <List.Content floated='right'>
                                {selectedAccount.timeZone}
                            </List.Content>
                            <List.Content >
                                <List.Header >Timezone</List.Header>
                            </List.Content>
                        </List.Item>
                        <List.Item className="singleLine">
                            <List.Content floated='right'>
                                <MomentDate />
                            </List.Content>
                            <List.Content >
                                <List.Header >Date format</List.Header>
                            </List.Content>
                        </List.Item>

                    </List>
                </Card.Content>
            </Card>
        );
    }
}
